import logoImage from '@/assets/jobfit-ai-logo.png';
import logoMark from '@/assets/jobfit-ai-mark.png';

const sizeClasses = {
  auth: 'h-28 w-28'
};

const compactClasses = {
  header: {
    image: 'h-9 w-9',
    text: 'hidden text-xl font-bold sm:inline'
  },
  footer: {
    image: 'h-7 w-7',
    text: 'text-base font-semibold'
  },
  drawer: {
    image: 'h-9 w-9',
    text: 'text-xl font-bold'
  }
};

export default function AppLogo({
  variant = 'header',
  className = '',
  'data-testid': testId = 'app-logo',
  ...props
}) {
  if (variant === 'auth') {
    return (
      <img
        src={logoImage}
        alt="JobFit AI"
        className={`${sizeClasses[variant]} object-contain rounded-md ${className}`}
        data-testid={testId}
        {...props}
      />
    );
  }

  const compact = compactClasses[variant] || compactClasses.header;

  return (
    <span
      className={`inline-flex items-center gap-2 ${className}`}
      data-testid={testId}
      {...props}
    >
      <img
        src={logoMark}
        alt=""
        aria-hidden="true"
        className={`${compact.image} shrink-0 object-contain rounded-md`}
      />
      <span className={`font-heading text-foreground ${compact.text}`}>JobFit AI</span>
    </span>
  );
}
